/* src/components/inline-notification/inline-notification.component.scss */
:host {
  display: block;
  position: relative;
}
.inline-notification-icon {
  font-size: 40px;
  line-height: 1;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}
.inline-notification-content {
  margin-left: var(--risc-base-spacing)40px;
  border-left: 1px solid var(--vwui-border-color-light);
  padding: 10px 0 10px var(--risc-base-spacing);
}
/*# sourceMappingURL=inline-notification.component-ZCCDYQMC.css.map */
